module.exports = __webpack_public_path__ + "static/img/solu5.8c100f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu5.jpg
// module id = PXOB
// module chunks = 1